import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withMemo as _withMemo, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/imageFooter/BMW.svg'
import _imports_1 from '../../assets/imageFooter/Nissan.svg'
import _imports_2 from '../../assets/imageFooter/Volvo.png'
import _imports_3 from '../../assets/imageFooter/Suzuki.svg'
import _imports_4 from '../../assets/imageFooter/Yamaha.svg'
import _imports_5 from '../../assets/imageFooter/Opel.svg'


const _hoisted_1 = {
  key: 0,
  class: "mw-1440 display-none-media-1000"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"ml-5 mr-5 mb-5 pt-1 pl-4 pr-4 d-flex j-content-s-ar\"><img src=\"" + _imports_0 + "\" alt=\"bmv\"><img src=\"" + _imports_1 + "\" alt=\"nissan\"><img src=\"" + _imports_2 + "\" alt=\"volvo\"><img src=\"" + _imports_3 + "\" alt=\"suzuki\"><img src=\"" + _imports_4 + "\" alt=\"yamaha\"><img src=\"" + _imports_5 + "\" alt=\"opel\"></section>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "mw-1440" }
const _hoisted_5 = { class: "ml-5 mr-5 pl-4 pr-4 d-flex" }
const _hoisted_6 = { class: "contact-wrapper mb-1 w-100" }
const _hoisted_7 = { class: "text-motserrat-15-bold t-white mb-1" }
const _hoisted_8 = { class: "text-motserrat-13-light t-white mt-1" }
const _hoisted_9 = { class: "text-motserrat-13-light t-white mt-1 mb-1" }
const _hoisted_10 = { class: "w-100 d-flex a-i-end j-content-end" }
const _hoisted_11 = { class: "user_data mb-1 d-flex" }
const _hoisted_12 = { class: "text-motserrat-13-light t-white w-100 text-center" }
const _hoisted_13 = { class: "text-motserrat-13-light t-white w-100 text-center" }
const _hoisted_14 = { class: "text-motserrat-13-light t-white w-100 text-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-motserrat-12-light text-center t-white ml-9 mr-9 bt-solid pt-1" }, " Tyre Point © 2023 ", -1)

import { Costumers } from "@/store/modules/Customers/type";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { store } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

const route = useRoute();
const serverVersion = ref(process.env.VUE_APP_FRONTEND_VERSION);
const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));
const serverType = ref(computed<string>(() => store.getters.getServerType));

const userCustomer = ref(
  computed<Costumers[]>(() => store.getters.getUserCustomerData)
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return _withMemo([_unref(route).name === 'start', uiLang.value, userCustomer.value], () => (_openBlock(), _createElementBlock("footer", { class: "footer pt-5 pb-1 pl-5 pr-5" }, [
    (_unref(route).name === 'start' && serverType.value === 'retail')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.$tc("Contact us")), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$tc("Phone")) + ": 010 504 2268 ", 1),
          _createElementVNode("p", _hoisted_9, _toDisplayString(serverType.value !== "retail"
                ? _ctx.$tc("Email") + " : yritysmyynti@tyrepoint.fi"
                : _ctx.$tc("Email") + " : Info@tyrepoint.fi"), 1),
          _createVNode(_component_router_link, {
            class: "text-motserrat-13-light t-white mt-1 text-decoration-none",
            to: { name: 'private_policy' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tc("Privacy Policy")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "text-motserrat-13-light t-white mt-1 text-decoration-none ml-1",
            to: { name: 'contact_us' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tc("Contact us")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString((userCustomer.value || [])[0]?.sales_person_code || ""), 1),
            _createElementVNode("span", _hoisted_13, _toDisplayString((userCustomer.value || [])[0]?.firm_id || ""), 1),
            _createElementVNode("span", _hoisted_14, " version " + _toDisplayString(" " + (serverVersion.value || "")), 1)
          ])
        ])
      ]),
      _hoisted_15
    ])
  ])), _cache, 0)
}
}

})